module.exports = __webpack_public_path__ + "img/Artificial Intellignce in Asia.79eb83c9.jpg";